import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { API_ENDPOINTS } from "./api/config";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email) { setError("Please enter your email address."); return; }
    
    setLoading(true);

    try {
      const response = await fetch(API_ENDPOINTS.FORGOT_PASSWORD, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Something went wrong. Please try again.");
      }

      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="si-root">
      <div className="si-left">
        <Link to="/" className="su-logo">Rembo<span>List</span></Link>

        <div className="si-form-area">
          <div className="si-eyebrow">Recovery</div>
          <h1 className="si-title">Reset your<br /><em>password</em></h1>
          
          {!submitted ? (
            <>
              <p className="si-subtitle">
                Enter your email address and we'll send you a link to reset your password.
              </p>

              {error && <div className="si-error"><span>⚠</span>{error}</div>}

              <form onSubmit={handleSubmit}>
                <div className="si-field">
                  <label className="si-label">Email Address</label>
                  <input
                    className="si-input"
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                  />
                </div>

                <button className="si-btn" type="submit" disabled={loading}>
                  {loading ? <span className="si-spinner" /> : null}
                  {loading ? "Sending link…" : "Send Reset Link"}
                </button>
              </form>
            </>
          ) : (
            <div className="si-success-msg" style={{ marginTop: "1rem" }}>
              <p style={{ fontWeight: 500, marginBottom: "0.5rem" }}>Check your inbox!</p>
              <p style={{ opacity: 0.8, lineHeight: 1.5 }}>
                If an account exists for <strong>{email}</strong>, you will receive a password reset link shortly.
              </p>
              <button 
                className="si-panel-btn" 
                style={{ marginTop: "1.5rem", width: "100%", color: "#1a1a1a", borderColor: "#1a1a1a" }}
                onClick={() => navigate("/signin")}
              >
                Return to Sign In
              </button>
            </div>
          )}

          <div className="si-divider"><span>or</span></div>
          <div className="si-switch">
            Remembered your password?{" "}
            <a href="#" onClick={e => { e.preventDefault(); navigate("/signin"); }}>
              Back to Sign In
            </a>
          </div>
        </div>
        
        <p className="si-footer-note">
          Need help? <a href="mailto:support@rembolist.com">Contact Support</a>
        </p>
      </div>

      <div className="si-right">
        <div className="si-right-inner">
          <div className="si-panel-tag">Security First</div>
          <h2 className="si-panel-title">Protecting your<br /><em>digital craft</em></h2>
          <p className="si-panel-text">
            We use industry-standard encryption to ensure your account details 
            remain private and your connections secure.
          </p>
        </div>
      </div>
    </div>
  );
}